import { ICommonResponse } from 'api/types';
import { IModifiedReward } from 'types';
import { getAcademicYearByDate, isDateValid } from 'utils';

import { splittedDataToSortedArray } from './splittedDataToSortedArray';

export const splitRewardsByAcademicYear = (data: ICommonResponse<IModifiedReward>, academicYears: string[]) => {
  const learningYearData: Record<string, IModifiedReward[]> = {};

  data.content.forEach((item) => {
    // Награды без даты определяем к учебному году по дате создания
    const date = new Date(item.formData.date ?? item.formData.creationDate);
    if (isDateValid(date)) {
      const period = getAcademicYearByDate(date);
      if (academicYears.includes(period)) {
        if (learningYearData[period]) {
          learningYearData[period].push(item);
        } else {
          learningYearData[period] = [item];
        }
      }
    }
  });

  return splittedDataToSortedArray(learningYearData);
};
